import * as React from 'react';
import { Typography } from 'fronton-react';

import { text } from './layout-controlled-typography.styles';

type LayoutControlledTypographyProps = React.ComponentProps<typeof Typography>;

/**
 * CSS Custom Properties: @see file://./layout-controlled-typography.styles.ts
 */
export const LayoutControlledTypography: React.FC<LayoutControlledTypographyProps> = ({
  children,
  ...props
}) => {
  return (
    <Typography {...props}>
      <span className={text}>{children}</span>
    </Typography>
  );
};
